import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import Beautyfloatingbutton from "../../components/beautyfloatingbutton";
import "./home.css";


import dummy from "./facial.webp"
import banner2 from "./homebanner1.png"; // Your banner image
import banner1 from "./homebanner2.png"; // Your banner image
import banner3 from "./homebanner3.png"; // Your banner image

import facialcat from "../images/category/facialcategory.webp";
import cleanupcat from "../images/category/cleanupcategory.webp";
import detanbleachcat from "../images/category/detanbleachcategory.webp";
import manipedicat from "../images/category/manipedicategory.webp";
import hairbodypolishcat from "../images/category/hairbodypolishcategory.webp";
import packagescat from "../images/category/packagescategory.webp";
import waxandthreadcat from "../images/category/waxandthreadcategory.webp";
import bodyhairmessagecat from "../images/category/bodyhairmessagecategory.webp";

import hygineguaranteed from "../images/whychoose/hygineguaranteed.webp";
import ontimeservice from "../images/whychoose/ontimeservice.webp";
import premiumproducts from "../images/whychoose/premiumproducts.webp";
import safesecure from "../images/whychoose/safeandsecure.webp";
import trainedbeauticians from "../images/whychoose/trainedbeautician.webp";
import widecoverage from "../images/whychoose/widecoverage.webp";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";




function renderStars(rating) {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(
      <i
        key={i}
        className={`bi bi-star${i <= rating ? "-fill" : ""}`}
        style={{ color: i <= rating ? "gold" : "#ddd", marginRight: "2px" }}
        aria-hidden="true"
      ></i>
    );
  }
  return stars;
}

export default function HomePage() {
  const navigate = useNavigate();

  const bannerImages = [banner1, banner2, banner3];

  // Dummy data for products
  const whatsNewProducts = [
    { id: 1, name: "Refreshing Body Scrub", price: 1200, image: dummy },
    { id: 2, name: "Aromatic Facial", price: 1500, image: dummy },
    { id: 3, name: "Deep Tissue Massage", price: 2000, image: dummy },
    { id: 4, name: "Detox Spa", price: 1800, image: dummy },
  ];



  const trustSafety = [
    {
      id: 1,
      title: "Trained Professionals",
      description:
        "Our team is skilled and certified to ensure premium service quality.",
      icon: "bi-person-check",
    },
    {
      id: 2,
      title: "Hygienic Practices",
      description:
        "Strict sanitization to maintain your health and safety at all times.",
      icon: "bi-shield-lock",
    },
    {
      id: 3,
      title: "Customer Support",
      description:
        "24/7 assistance for bookings, queries, and feedback.",
      icon: "bi-headset",
    },
  ];


  const customerReviews = [
    {
      id: 1,
      name: "Sarah J.",
      rating: 5,
      review:
        "Amazing service! The staff was very professional and the experience was relaxing.",
    },
    {
      id: 2,
      name: "David K.",
      rating: 4,
      review:
        "Loved the ambiance and the quality of the facial treatments. Highly recommend!",
    },
    {
      id: 3,
      name: "Anita M.",
      rating: 5,
      review:
        "Best home salon experience I've ever had. Friendly staff and great results!",
    },
  ];

  return (
    <div style={{ backgroundColor: "#f7ead7", minHeight: "100vh" }}>
      {/* Header */}
      <Header />



      {/* Navbar */}
      <Navbar />

      {/* Hero Banner Section */}
      <section className="py-3">
        <div className="container">

          <div
            id="homeBannerCarousel"
            className="carousel slide premium-banner"
            data-bs-ride="carousel"
          >

            {/* Dots */}
            <div className="carousel-indicators">
              {[0, 1, 2].map((i) => (
                <button
                  key={i}
                  type="button"
                  data-bs-target="#homeBannerCarousel"
                  data-bs-slide-to={i}
                  className={i === 0 ? "active" : ""}
                  aria-current={i === 0 ? "true" : undefined}
                  aria-label={`Slide ${i + 1}`}
                ></button>
              ))}
            </div>

            {/* Slides */}
            <div className="carousel-inner">
              {[0, 1, 2].map((index) => (
                <div
                  key={index}
                  className={`carousel-item ${index === 0 ? "active" : ""}`}
                >
                  <div
                    className="banner-img"
                    style={{
                      backgroundImage: `url(${bannerImages[index]})`,
                    }}
                  >
                    {/* optional text center */}
                    <div className="banner-overlay text-shadow">
                      {/* you can add heading here later */}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Controls */}
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#homeBannerCarousel"
              data-bs-slide="prev"
            >
              <span className="carousel-control-prev-icon"></span>
            </button>

            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#homeBannerCarousel"
              data-bs-slide="next"
            >
              <span className="carousel-control-next-icon"></span>
            </button>

          </div>
        </div>
      </section>


      {/* Services We Offer */}
      <section className="container my-4">
        <h4 className="fw-bold mb-4 text-center">Salon Services at Your Doorstep</h4>

        <div className="row category-row justify-content-center">

          {[
            {
              title: "Packages",
              image: packagescat,
              description: "Bridal, Party, Full Beauty Combos",
              link: "/packages",
            },
            {
              title: "Facial",
              image: facialcat,
              description: "Glow, Clean-up, Advanced Facials",
              link: "/category/facialservices",
            },
            {
              title: "Waxing & Threading",
              image: waxandthreadcat,
              description: "Full Body Wax, Eyebrow, Upper lip",
              link: "/category/waxing",
            },
            {
              title: "Clean-Up",
              image: cleanupcat,
              description: "Express, Detan, Skin Clean-up",
              link: "/category/cleanupservices",
            },
            {
              title: "Mani-Pedi",
              image: manipedicat,
              description: "Manicure, Pedicure, Foot Spa",
              link: "/category/manipediservices",
            },
            {
              title: "Detan & Bleach",
              image: detanbleachcat,
              description: "Detan, Bleach",
              link: "/category/detanbleach",
            },
            {
              title: "Body Polish & Hair Spa",
              image: hairbodypolishcat,
              description: "Body Glow, Scrub & Polish",
              link: "/category/hairbodypolish",
            },
            {
              title: "Body & Head Massage",
              image: bodyhairmessagecat,
              description: "Relaxing Body & Head Massage",
              link: "/category/bodyhairmessage",
            },
          ].map((service, idx) => (
            <div key={idx} className="col-4 col-sm-3 col-md-3 col-lg-2">

              <div className="category-card shadow-sm rounded-3 p-2 text-center bg-white hover-scale h-100 d-flex flex-column">

                <img
                  src={service.image}
                  alt={service.title}
                  className="category-img rounded-2 mb-2"
                  loading="lazy"
                />


                <h6 className="fw-semibold mb-1" style={{ fontSize: "0.9rem" }}>
                  {service.title}
                </h6>

                <p className="text-muted mb-2 flex-grow-1" style={{ fontSize: "0.75rem" }}>
                  {service.description}
                </p>

                <button
                  className="btn btn-sm btn-primary mt-auto"
                  onClick={() => navigate(service.link)}
                >
                  Explore
                </button>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center mt-4 text-muted" style={{ fontSize: "0.85rem" }}>
          50+ premium beauty services, delivered to your doorstep.
        </p>

        <div className="text-center">
          <a href="/category" className="btn btn-outline-primary btn-sm">
            View All Services
          </a>
        </div>
      </section>


      {/* Trust and Safety */}
      <section className="container py-5">
        <h2 className="fw-bold mb-3 text-center">Trust & Safety</h2>
        <p className="text-center text-muted mb-4" style={{ maxWidth: "600px", margin: "0 auto" }}>
          Your safety and trust are our top priorities. Every service is delivered with care, hygiene, and professionalism.
        </p>
        <div className="row gy-4">
          {trustSafety.map(({ id, title, description, icon }) => (
            <div key={id} className="col-12 col-sm-4 d-flex justify-content-center">
              <div
                className="trust-card card shadow-sm p-3"
                style={{
                  maxWidth: "320px",
                  width: "100%",
                  borderRadius: "15px",
                  textAlign: "center",
                }}
              >
                <i className={`bi ${icon} text-primary mb-2 fs-3 fs-sm-1`} aria-hidden="true"></i>
                <h5 className="fw-semibold fs-6 mb-1">{title}</h5>
                <p className="text-muted small mb-0">{description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>


      {/* What's New - Scrollable */}
      <section className="container py-5">
        <h2 className="fw-bold mb-3 text-center">What's New?</h2>
        <p className="text-muted text-center small mb-4">
          Swipe to explore the latest services ➡️
        </p>

        <div
          className="whatsnew-scroll d-flex overflow-auto px-2"
          role="region"
          aria-label="New services"
        >
          {whatsNewProducts.map(({ id, name, price, image }) => (
            <article
              key={id}
              className="card whatsnew-card shadow-sm p-2 flex-shrink-0"
              tabIndex={0}
              aria-label={`${name}, Rs ${price}`}
            >
              <img
                src={image}
                alt={name}
                className="card-img-top rounded-2 mb-2 whatsnew-img"
                loading="lazy"
              />
              <h3 className="card-title fs-6 mb-1">{name}</h3>
              <p className="text-muted fs-6 mb-2">Rs. {price}</p>
              <button className="btn btn-sm btn-primary w-100">Book Now</button>
              <small className="text-muted d-block text-center mt-2">
                Limited slots available
              </small>
            </article>
          ))}
        </div>
      </section>


      {/* Best Selling Services - Scrollable */}
      <section className="container py-5">
        <h2 className="fw-bold mb-3 text-center">Our Best Selling Services</h2>
        <p className="text-muted text-center small mb-4">
          Swipe to explore our most booked services ➡️
        </p>

        <div
          className="bestseller-scroll d-flex overflow-auto px-2"
          role="region"
          aria-label="Best selling services"
        >
          {whatsNewProducts.map(({ id, name, price, image }) => (
            <article
              key={id}
              className="card bestseller-card shadow-sm p-2 flex-shrink-0"
              tabIndex={0}
              aria-label={`${name}, Rs ${price}`}
            >
              <img
                src={image}
                alt={name}
                className="card-img-top rounded-2 mb-2 bestseller-img"
                loading="lazy"
              />
              <h3 className="card-title fs-6 mb-1">{name}</h3>
              <p className="text-muted fs-6 mb-2">Rs. {price}</p>

              <button className="btn btn-sm btn-primary w-100">
                Book Now
              </button>

              <small className="text-muted d-block text-center mt-2">
                ⭐ Most booked this week
              </small>
            </article>
          ))}
        </div>
      </section>


      {/* Why Choosing Us */}
      <section className="container py-5">
        <h2 className="fw-bold mb-4 text-center">Why Choosing Us</h2>
        <div className="row gy-4">
          <div className="col-6 col-sm-4 d-flex justify-content-center">
            <div className="card why-card shadow-sm" style={{ maxWidth: "300px", width: "100%", borderRadius: "15px" }}>
              <img src={trainedbeauticians} alt="" className="why-img" />

              <div className="text-center">
                <h5 className="fw-semibold fs-6">Trained Beauticians</h5>
                <p className="text-muted fs-6">All staff are certified & trained to deliver top-notch service.</p>
              </div>
            </div>
          </div>

          <div className="col-6 col-sm-4 d-flex justify-content-center">
            <div className="card why-card shadow-sm" style={{ maxWidth: "300px", width: "100%", borderRadius: "15px" }}>
              <img src={premiumproducts} alt="" className="why-img" />

              <div className="text-center">
                <h5 className="fw-semibold fs-6">Premium Products</h5>
                <p className="text-muted fs-6">We use Thalgo, O3+, Rica & other premium brands only.</p>
              </div>
            </div>
          </div>

          <div className="col-6 col-sm-4 d-flex justify-content-center">
            <div className="card why-card shadow-sm" style={{ maxWidth: "300px", width: "100%", borderRadius: "15px" }}>
              <img src={ontimeservice} alt="" className="why-img" />
              <div className="text-center">
                <h5 className="fw-semibold fs-6">On-Time Service</h5>
                <p className="text-muted fs-6">Punctual beauticians ensure your schedule is respected.</p>
              </div>
            </div>
          </div>

          <div className="col-6 col-sm-4 d-flex justify-content-center">
            <div className="card why-card shadow-sm" style={{ maxWidth: "300px", width: "100%", borderRadius: "15px" }}>
              <img src={hygineguaranteed} alt="" className="why-img" />
              <div className="text-center">
                <h5 className="fw-semibold fs-6">Hygiene Guaranteed</h5>
                <p className="text-muted fs-6">Sanitized kits & disposable tools used for every session.</p>
              </div>
            </div>
          </div>

          <div className="col-6 col-sm-4 d-flex justify-content-center">
            <div className="card why-card shadow-sm" style={{ maxWidth: "300px", width: "100%", borderRadius: "15px" }}>
              <img src={widecoverage} alt="" className="why-img" />
              <div className="text-center">
                <h5 className="fw-semibold fs-6">Wide Coverage</h5>
                <p className="text-muted fs-6">Available in all areas across Kolkata from Day 1.</p>
              </div>
            </div>
          </div>

          <div className="col-6 col-sm-4 d-flex justify-content-center">
            <div className="card why-card shadow-sm" style={{ maxWidth: "300px", width: "100%", borderRadius: "15px" }}>
              <img src={safesecure} alt="" className="why-img" />
              <div className="text-center">
                <h5 className="fw-semibold fs-6">Safe & Secure</h5>
                <p className="text-muted fs-6">Relax with confidence — Your safety is our priority.</p>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="container py-5">
        <h2 className="fw-bold mb-4 text-center">Customer Reviews</h2>
        <div className="row gy-4">
          {customerReviews.map(({ id, name, rating, review }) => (
            <div key={id} className="col-12 col-sm-4 d-flex justify-content-center">
              <div
                className="card shadow-sm p-3 position-relative"
                style={{ maxWidth: "320px", width: "100%", borderRadius: "15px" }}
              >
                <div className="d-flex align-items-center mb-2">
                  {/* User Icon */}
                  <div
                    className="d-flex justify-content-center align-items-center rounded-circle bg-light me-2"
                    style={{ width: "40px", height: "40px", fontSize: "20px" }}
                  >
                    <i className="bi bi-person-circle fs-4"></i>
                  </div>
                  <div>
                    <h6 className="mb-0 fw-semibold">{name}</h6>
                    <small className="text-muted">• July 2025</small>
                  </div>
                  <div className="ms-auto">{renderStars(rating)}</div>
                </div>
                <p className="text-muted fs-6">
                  {review.length > 120 ? `${review.slice(0, 120)}...` : review}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <Footer />
      <Beautyfloatingbutton />

      {/* CTA Section */}





    </div>
  );
}
